import { useEffect } from "react";
import "./GuidedNavigation.css";
import "./GuidedNavigationTypography.css";

const PRIMARY_ITEMS = [
  { id: "live", icon: "📈", label: "Trading Center" },
  { id: "guided-tour", icon: "🚀", label: "Guided Tour" },
  { id: "nina", icon: "🤖", label: "AI Assistant" },
  { id: "scanner", icon: "🔍", label: "Scanner", tourId: "scanner" },
  {
    id: "portfolio",
    icon: "◫",
    label: "Portfolio",
    badge: "SOURCE OF TRUTH",
    tourId: "portfolio",
  },
  { id: "watchlist", icon: "☷", label: "Watchlist" },
  { id: "journal", icon: "📓", label: "Journal", tourId: "journal" },
  { id: "tax-forms", icon: "🧾", label: "Tax Forms", tourId: "tax-forms" },
  { id: "academy", icon: "🎓", label: "Academy", tourId: "academy" },
  { id: "nina-status", icon: "◉", label: "AI Status" },
  { id: "market-clock", icon: "◷", label: "Market Clock" },
];

const FOOTER_ITEMS = [
  { id: "dashboard", icon: "🏠", label: "Home" },
  { id: "profile", icon: "P", label: "Profile" },
  { id: "settings", icon: "⚙", label: "Settings", tourId: "settings" },
];

const WORKFLOW_STEPS = [
  { icon: "📈", label: "Trade" },
  { icon: "✦", label: "Ask AI Assistant" },
  { icon: "⌖", label: "Discover" },
  { icon: "▣", label: "Manage" },
  { icon: "▤", label: "Learn" },
];

function NavigationButton({ item, activePage, onNavigate }) {
  return (
    <button
      type="button"
      className={`guidedNavigation__button${
        activePage === item.id ? " activeNavButton" : ""
      }`}
      aria-current={activePage === item.id ? "page" : undefined}
      data-tour-id={item.tourId}
      onClick={() => onNavigate(item.id)}
    >
      <span className="guidedNavigation__icon" aria-hidden="true">
        {item.icon}
      </span>
      <span className="guidedNavigation__content">
        <span className="guidedNavigation__label">{item.label}</span>
        {item.badge && (
          <span className="guidedNavigation__badge">{item.badge}</span>
        )}
      </span>
    </button>
  );
}

function GuidedNavigation({ activePage, onNavigate }) {
  useEffect(() => {
    const openLiveTrading = (event) =>
      onNavigate("live", { scannerHandoff: event.detail || null });
    window.addEventListener("nina:scanner-open-live", openLiveTrading);
    return () => window.removeEventListener("nina:scanner-open-live", openLiveTrading);
  }, [onNavigate]);

  return (
    <div className="guidedNavigation">
      <section
        className="guidedNavigation__journey"
        aria-label="Guided platform workflow"
      >
        <span className="guidedNavigation__eyebrow">GUIDED WORKFLOW</span>
        <ol className="guidedNavigation__steps">
          {WORKFLOW_STEPS.map((step, index) => (
            <li key={step.label}>
              <div className="guidedNavigation__step">
                <span aria-hidden="true">{step.icon}</span>
                <strong>{step.label}</strong>
              </div>
              {index < WORKFLOW_STEPS.length - 1 && (
                <span className="guidedNavigation__arrow" aria-hidden="true">
                  ↓
                </span>
              )}
            </li>
          ))}
        </ol>
      </section>

      <nav
        id="anina-primary-navigation"
        className="guidedNavigation__items"
        aria-label="Primary navigation"
      >
        {PRIMARY_ITEMS.map((item) => (
          <NavigationButton
            key={item.id}
            item={item}
            activePage={activePage}
            onNavigate={onNavigate}
          />
        ))}
      </nav>

      <nav className="guidedNavigation__footerItems" aria-label="General navigation">
        {FOOTER_ITEMS.map((item) => (
          <NavigationButton
            key={item.id}
            item={item}
            activePage={activePage}
            onNavigate={onNavigate}
          />
        ))}
      </nav>
    </div>
  );
}

export default GuidedNavigation;
